import { environment as coreEnvironment } from '@core/../environments/environment.test';

export const environment: any = {
  ...coreEnvironment,
};
